// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const BackArrowLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9">
            <path
                fill="currentColor"
                d="M10.4787894,4.5 C10.4787894,4.91484404 10.1647271,5.25 9.74988306,5.25 L2.56160152,5.25 L5.03191423,7.72031236 C5.32488298,8.01328111 5.32488298,8.48789048 5.03191423,8.78085923 C4.88425756,8.92734361 4.69207013,9 4.4998827,9 C4.30769527,9 4.11597633,8.92675781 3.96972656,8.78027344 L0.219726563,5.03027344 C-0.0732421875,4.73730469 -0.0732421875,4.26269531 0.219726563,3.96972656 L3.96972656,0.219726562 C4.26269531,-0.0732421875 4.73730469,-0.0732421875 5.03027344,0.219726562 C5.32324219,0.512695312 5.32324219,0.987304688 5.03027344,1.28027344 L2.56160152,3.75 L9.74988306,3.75 C10.1647271,3.75 10.4787894,4.08515632 10.4787894,4.5 Z"
            />
        </svg>
    );
};

export default React.memo(BackArrowLeft);
